import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconThumbsDown({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.155 16.465a.47.47 0 0 0 .174-.196l1.618-3.251a.506.506 0 0 0 .053-.225V7.505H8.358a.502.502 0 0 0-.495.426l-.857 5.602h3.404c.628 0 1.07.561 1 1.149-.053.432-.063.86.033 1.197.088.305.251.513.583.61.033.008.073.008.13-.024zM17 8.007a.501.501 0 0 0-.5-.502H15v4.52h1.5c.276 0 .5-.224.5-.502V8.008zM6.01 13.421l.865-5.644A1.503 1.503 0 0 1 8.358 6.5H16.5c.828 0 1.5.675 1.5 1.507v3.517c0 .832-.672 1.507-1.5 1.507h-1.52a1.51 1.51 0 0 1-.138.436l-1.618 3.252c-.233.466-.795.932-1.475.735-.726-.21-1.104-.73-1.267-1.297-.153-.537-.122-1.131-.066-1.596a.03.03 0 0 0-.006-.022v-.001H6.964a.967.967 0 0 1-.954-1.117z" fill={fill}/>
        </svg>
    );
}

export default IconThumbsDown;
